var exports = {
  "kL": "container__Woawlr",
  "Zg": "isSelectable__Xu5Fva",
  "_o": "centerAligned__SEGqba",
};

module.exports = exports;
